import React, { useState, useEffect } from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  useTranslate,
  required,
  useNotify,
} from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { Grid, Skeleton } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { NumberInput } from 'src/components/uiElements/fields/NumberInput'
import { productServices } from 'src/services/reservation/product/product.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { HasPermission } from 'src/helper/HasPermission'
import { FormFiscalData } from '../../administration/business-unit/logic/FormFiscalData'

export const SupplierCreate = (props) => {
  const notify = useNotify()
  const translate = useTranslate()
  const [productTypes, setProductTypes] = useState([])
  const [loadingProductTypes, setLoadingProductTypes] = useState(false)

  const supplierTypes = [{id:1, name:'Aéreo'}, {id:2, name:'Hotel'}, {id:3, name:'Otros prestadores turísticos'}]

  useEffect(() => {
    ;(async () => {
      try {
        setLoadingProductTypes(true)
        const response = await productServices.getAllProductTypes()
        setProductTypes(response)
        setLoadingProductTypes(false)
      } catch (error) {
        notify(`product types not found`, { type: 'error' })
        setLoadingProductTypes(false)
        return null
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Create {...props} redirect='list' actions={null}>
      <CardCommon title={translate('ra.entity.supplier')} actions={null}>
        <SimpleForm>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput validate={required()} label={false} fullWidth source='name' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.code')} required>
              <TextInput validate={required()} label={false} fullWidth source='code' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.tma_code')} required>
              <TextInput validate={required()} label={false} fullWidth source='billing_code' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.is_active')}>
              <BooleanInput label={false} fullWidth source='is_active' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.vat_active')}>
              <BooleanInput label={false} fullWidth source='vat_active' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.gmx_contract_id')}>
              <NumberInput label={false} fullWidth source='gmx_contract_id' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.product-type')} required>
              {loadingProductTypes ? (
                <Skeleton variant='rectangular' height={40} />
              ) : (
                <SelectInput
                  source='product_type_id'
                  optionsText={['long_name']}
                  optionValue='id'
                  options={productTypes}
                  label=''
                  fullWidth
                  validate={[required()]}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.supplier_type')}>
              {loadingProductTypes ? (
                <Skeleton variant='rectangular' height={40} />
              ) : (
                <SelectInput
                  source='supplier_type'
                  optionsText={['name']}
                  optionValue='id'
                  options={supplierTypes}
                  label=''
                  fullWidth
                  validate={[required()]}
                />
              )}
            </EditInputsWrap>
          </Grid>
          <HasPermission permission='fiscal_data' resource={'supplier'}>
            <div style={{marginTop:'80px'}}>
              <FormFiscalData isSupplier={true}/>
            </div>
          </HasPermission>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
